export default __webpack_public_path__ + "static/media/deepak-prasad.a7ca827d.jpg";